const notification = {
  state: {
    notificationContainerDisplay : false,
    notifications:[],
  },
  getters: {
    notificationContainerDisplay(state) { return state.notificationContainerDisplay },
    notifications(state) { return state.notifications },
  },
  mutations: {
    setNotificationContainerDisplay (state, value) {
      state.notificationContainerDisplay = value
    },
    setNotifications (state, value) {
      state.notifications = value
    },
  },
  actions: {},
  modules: {}
}
export default notification